import React from 'react';
import './ProcessPlant.css';

const ProcessPlant = () => {
  const services = [
    {
      id: 1,
      title: "Feasibility Studies & Concept Development",
      items: [
        { title: "Feasibility Studies", description: "Analyzing viability and potential challenges for new projects." },
        { title: "Conceptual Design", description: "Developing initial layouts, PFDs, and preliminary cost estimates." },
        { title: "Risk Assessments", description: "Identifying safety, environmental, and financial risks and mitigation strategies." }
      ]
    },
    {
      id: 2,
      title: "Process Engineering",
      items: [
        { title: "Process Design", description: "Creating detailed PFDs and P&IDs for plant processes." },
        { title: "Process Simulation", description: "Using simulation software for process optimization." },
        { title: "Equipment Sizing", description: "Sizing reactors, pumps, and compressors with vendor selection." },
        { title: "Process Optimization", description: "Improving efficiency and yield of existing processes." }
      ]
    },
    {
      id: 3,
      title: "Detailed Engineering Design",
      items: [
        { title: "Mechanical Design", description: "Design of pressure vessels, heat exchangers, and storage tanks." },
        { title: "Electrical & Instrumentation", description: "Design of electrical distribution and control systems." },
        { title: "Civil & Structural", description: "Foundation and structural design for equipment and buildings." },
        { title: "Piping Design", description: "Comprehensive piping layout and support design." }
      ]
    },
    {
      id: 4,
      title: "Procurement & Vendor Coordination",
      items: [
        { title: "Procurement Support", description: "Specifications, bid evaluations, and procurement support." },
        { title: "Vendor Management", description: "Coordinating with vendors and ensuring specification compliance." }
      ]
    },
    {
      id: 5,
      title: "Construction & Commissioning Support",
      items: [
        { title: "Construction Management", description: "On-site support including quality checks and progress tracking." },
        { title: "Construction Drawing", description: "Detailed drawings for vessels, tanks, and equipment platforms." }
      ]
    },
    {
      id: 6,
      title: "Project Management",
      items: [
        { title: "Project Planning", description: "Development of timelines and resource allocation." },
        { title: "Cost Control", description: "Budget preparation, monitoring, and cost-tracking." },
        { title: "Documentation", description: "Managing project documentation and regulatory compliance." }
      ]
    },
    {
      id: 7,
      title: "Safety, Environmental, and Regulatory Compliance",
      items: [
        { title: "Hazard Analysis", description: "Conducting HAZOP studies for safety compliance." },
        { title: "Environmental Impact", description: "Analyzing environmental impacts and sustainability." },
        { title: "Regulatory Compliance", description: "Ensuring adherence to ASME, API, OSHA, and EPA standards." }
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Process Plant</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Process Plant Services Section */}
      <div className="bim-services">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-6 col-md-12">
                <div className="service-item">
                  <div className="service-header">
                    <div className="service-number">{String(service.id).padStart(2, '0')}</div>
                    <h3>{service.title}</h3>
                  </div>
                  <div className="service-content">
                    <ul>
                      {service.items.map((item, index) => (
                        <li key={index}>
                          <strong>{item.title}:</strong> {item.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcessPlant;
